import { StateCreator } from 'zustand';
import { BunkerExMutation } from '../../graphql';
import { GlobalStore, useGlobalStore } from './store';

export type BunkerExSlice = {
  bunkerEx: BunkerExMutation['bunkerEx'];
  setBunkerEx: (bunkerEx: BunkerExMutation['bunkerEx']) => void;
};

export const createBunkerExSlice: StateCreator<BunkerExSlice> = (setSate) => ({
  bunkerEx: null,
  setBunkerEx: (bunkerEx: BunkerExMutation['bunkerEx']) => {
    setSate({ bunkerEx });
  },
});

/*
 * Memoized selectors
 * https://docs.pmnd.rs/zustand/recipes/recipes#memoizing-selectors
 */
const bunkerExSelector = (s: GlobalStore) => s.bunkerEx;
const setBunkerExSelector = (s: GlobalStore) => s.setBunkerEx;

export function useBunkerEx() {
  return useGlobalStore(bunkerExSelector);
}

export function useSetBunkerEx() {
  return useGlobalStore(setBunkerExSelector);
}
